import MiddleBar from './MiddleBar';

export default MiddleBar;
